import { defineNuxtPlugin } from 'nuxt/app'
import dayjs from '~/lib/dayjs'

declare module '~/types/vue-shim' {
  interface AppGlobalProperties {
    $dayjs: typeof dayjs
  }
}

export default defineNuxtPlugin(() => {
  return {
    provide: {
      dayjs: dayjs,
    },
  }
})
